import React, { useState, useEffect } from "react";
import style from "./css/SelectUserTypePage.module.css";
import { apiURL_BACKEND ,UserDataInterface} from "./Vars";
import axios from "axios";
import { useNavigate } from "react-router-dom";
interface SelectUserTypeProps {

}

const SelectUserTypePage: React.FC<SelectUserTypeProps> = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState<UserDataInterface>();
    useEffect(() => {
        const res = axios.get(`${apiURL_BACKEND}/getUser/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            var data = res.data;
            console.log(data);

            setUserData({
                username: data.username,
                email: data.email,
                referrer: data.referrer,
                refer_code: data.refer_code,
                date_joined: data.date_joined,
                package: data.package,
                balance:data.balance,
                user_type:data.user_type,
                tme_username:data.tme_username
            })
        });
    }, [])

    const setUserType = (user_type:string)=>{
        const res = axios.post(`${apiURL_BACKEND}/setUserType/`,{
            "user_type":user_type
        },{
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res)=>{
            var data = res.data;

            var message = data.message;
            setTimeout(()=>{
                navigate("/upgrade/");
            },2000)
            alert(message);

        }).catch((err)=>{
            console.log(err);
        })
    }
    return (
        <>
            <div className={style.userSelect}>
                <div className={style.userTypeContainer}>
                    <button className={style.userType} onClick={(e)=>{e.preventDefault();setUserType("Agent");}}>
                        <p>I am an Agent</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20L10.575 18.6L16.175 13Z" fill="#5F6368" />
                        </svg>
                    </button>
                    <button className={style.userType} onClick={(e)=>{e.preventDefault();setUserType("Bettor");}}>
                        <p>I am a Bettor</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20L10.575 18.6L16.175 13Z" fill="#5F6368" />
                        </svg>
                    </button>
                </div>
            </div>

        </>
    );
};

export default SelectUserTypePage;
